import kr from 'Kr/kr';
import Swiper, {Navigation, EffectFade, Autoplay} from 'swiper';
Swiper.use([EffectFade, Autoplay, Navigation]);

export default class LayoutSlider extends kr.Component {
    init() {

        this.els = {
            slider: this.$element.querySelector('.js_slider'),
            nav_prev: this.$element.querySelector('.slider__nav--prev'),
            nav_next: this.$element.querySelector('.slider__nav--next'),
        };

        for (let i in this.els) {
            if (typeof this.els[i] === 'undefined' || this.els[i] == null) {
                return false;
            }
        }

        this.slider = new Swiper(this.els.slider, {
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 7000,
            },
            navigation: {
                nextEl: this.els.nav_next,
                prevEl: this.els.nav_prev,
            },
            effect: 'fade',
        });   

        this._event();
    }

    _event() {
        this.on('mouseenter', (event, current) => {
            this.slider.autoplay.stop();
        });
        this.on('mouseleave', (event, current) => {
            this.slider.autoplay.start();
        });
    }
}

kr.registerComponent('.section--slider', {
    component: LayoutSlider
});
